import { render } from "./BottomTabPageView.vue?vue&type=template&id=178d4856&scoped=true"
import script from "./BottomTabPageView.vue?vue&type=script&lang=js"
export * from "./BottomTabPageView.vue?vue&type=script&lang=js"

import "./BottomTabPageView.vue?vue&type=style&index=0&id=178d4856&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-178d4856"]])

export default __exports__